import { useRef } from "react";

export const useModalRegionRef = () => useRef(document.getElementById("modal_region") as HTMLDivElement);
